import { FC, memo, useMemo, CSSProperties } from 'react';
import FromIconFont from './fromIconFont';
import { IconFontProps } from './interface';

const icon_prev = 'yonboo-';
const IconFont: FC<IconFontProps> = memo(props => {
  const { type, size, color, active, activeColor } = props;
  const iconStyle: CSSProperties = useMemo(() => {
    const newIconStyle: CSSProperties = {};
    if (size) newIconStyle.fontSize = `${size}px`;
    if (color) newIconStyle.color = color;
    if (active) newIconStyle.color = activeColor;
    return newIconStyle;
  }, [ size, color, active, activeColor ]);
  if (!type) return null;
  const newType = type?.startsWith(icon_prev) ? type : `${icon_prev}${type}`;
  return (
    <FromIconFont type={newType} style={iconStyle} />
  );
});

IconFont.defaultProps = {
  size: 18,
  color: '#333',
  activeColor: '#1890ff',
};

export default IconFont;
